import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import '../styles/PrivacyPolicy.css';

const PrivacyPolicy = () => {
  const navigate = useNavigate();
  const privacyPolicy = `
Privacy Policy
Last Updated: April 2, 2025

1. Introduction
At Sync, we value your privacy. This Privacy Policy explains how we collect, use, and protect your information when you use our music collaboration platform and SyncPro subscription.

2. Information We Collect
We collect:
   - Account Information: Name, email, and password when you sign up.
   - User Content: Music, lyrics, or other content you upload.
   - Usage Data: Platform streams, interactions, and device info (e.g., IP address, OS) to operate Sync and calculate SyncPro payouts.
   - Payment Information: Billing details for SyncPro subscriptions, processed via Stripe, which may store this data separately.

3. How We Use Your Information
We use your data to:
   - Provide and improve Sync’s services.
   - Calculate and distribute SyncPro revenue (80% to artists based on stream percentage; 20% retained by Sync).
   - Communicate with you (e.g., updates, support).
   - Analyze usage to enhance features and ensure security.

4. Sharing Your Information
We do not sell your personal data. We may share it:
   - With artists, to attribute streams and distribute SyncPro revenue.
   - With service providers (e.g., payment processors, hosting services) under strict confidentiality.
   - If required by law or to protect Sync’s rights.

5. Data Retention
We retain account and usage data while your account is active and as needed for legal or operational purposes. User Content may persist for platform use under the license in the Terms of Service, even after account closure.

6. Your Rights
You may access, update, or delete your account data by contacting us at hello@syncmusic.app or using the delete account button in the profile page. Note that deleting your account may not remove User Content already shared or licensed.

7. Security
We use reasonable measures (e.g., encryption, access controls) to protect your data but cannot guarantee absolute security.

8. Changes to This Policy
We may update this Privacy Policy. Changes will be posted here, and significant updates may be notified via email or in-app.

9. Contact Us
Questions? Reach us at hello@syncmusic.app.
  `;

  return (
    <div className="privacy-policy-container">
      <div className="header-container">
        <button className="back-button" onClick={() => navigate(-1)}>
          <FaArrowLeft size={24} />
        </button>
        <h1 className="header">Privacy Policy</h1>
        <div className="placeholder"></div>
      </div>
      <div className="content">
        <p className="text">{privacyPolicy}</p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;